import type { CollectionItem } from "@/services/collection/item/collectionItemTypes";

export enum PopupType {
  ItemCreated,
  EmailNotVerified,
  EmailVerificationResent,
}

type PopupPayloadMap = {
  [PopupType.ItemCreated]: CollectionItem;
  [PopupType.EmailNotVerified]: undefined;
  [PopupType.EmailVerificationResent]: undefined;
};

const toShowList = ref<Map<PopupType, PopupPayloadMap[PopupType]>>(new Map());

export function usePopupNotifications() {
  function show<T extends PopupType>(type: T, ...args: PopupPayloadMap[T] extends undefined ? [] : [PopupPayloadMap[T]]): void {
    toShowList.value.set(type, args[0] as PopupPayloadMap[T]);
  }

  function getPayload<T extends PopupType>(type: T): PopupPayloadMap[T] | undefined {
    return toShowList.value.get(type) as PopupPayloadMap[T] | undefined;
  }

  const markClosed = (type: PopupType): void => {
    toShowList.value.delete(type);
  };

  return {
    toShowList,
    show,
    getPayload,
    markClosed,
  };
}
